var tt_skrollr_obj = undefined;

var ttSkrollr = {
  root_el_name: 'html',

  init: function (root_id) {
    var s = this;
    var root_el = root_id ? $('#'+root_id) : $('body');

    // if (isPhone) return;

    // if (isMobile) {
    //   $('.mobile_no_skrollr, .mobile_no_skrollr *').removeAttr('data-top data-bottom data-bottom-top data-top-bottom data-center data-center-top data-center-bottom');
    // }

    // root_el.find('.video-wrap').attr({
    //   'data-bottom-top': '',
    //   'data-top-bottom': '',
    //   'data-emit-events': ''
    // });

    // if ($('html').is('.mac.safari')) {
    //   root_el.find('.anim_emt:not(:in-viewport)').attr({
    //     'data-90-top-bottom': '',
    //     'data--40-bottom-top': '',
    //     'data-emit-events': ''
    //   });
    // }

    root_el.find('.skrollr-parallax-wrap').each(function (i) {
      var th = $(this);
      var img_el = th.find('.skrollr-parallax-img');
      var wrap_id = 'palx-wrap-' + i;

      th.attr('id', wrap_id);

      img_el.attr({
        'data-bottom-top': 'transform: translate3d(0,-20%,0)',
        // 'data-center': 'transform: translate3d(0,-8.3%,0)',
        'data-top': 'transform: translate3d(0,0%,0)',
        'data-top-bottom': 'transform: translate3d(0,20%,0)',
        'data-anchor-target': '#' + wrap_id
      });
    });

    // root_el.find('.skrollr-scale-wrap').each(function (i) {
    //   var th = $(this);
    //   var img_el = th.find('.skrollr-scale-img');
    //   var wrap_id = 'scale-wrap-' + i;

    //   th.attr('id', wrap_id);

    //   img_el.attr({
    //     'data-bottom-top': 'transform: scale(1)',
    //     // 'data-center': 'transform: scale(1)',
    //     'data-top': 'transform: scale(1.2)',
    //     // 'data-top-bottom': 'transform: scale()',
    //     'data-anchor-target': '#' + wrap_id
    //   });
    // });
    

    if (root_el.find('[data-anchor-target]').length) {
      // if ((window['skrollr_obj_' + obj_id]) != undefined) window['skrollr_obj_' + obj_id].refresh();
      if (tt_skrollr_obj != undefined) s.kill(s.root_el_name);
      s.root_el_name = root_id ? root_id : 'html';
      s.skrInit();
    }
    
  },

  skrInit: function () {
    var s = this;
    var root_el = s.root_el_name == 'html' ? $('body') : $('#'+s.root_el_name);
    var scroll_wrap = s.root_el_name == 'html' ? '' : s.root_el_name;
    // console.log('scroll_wrap: ' + scroll_wrap);
    
    tt_skrollr_obj = skrollr.init({
      scrollElement: scroll_wrap,
      // edgeStrategy: 'set',
      forceHeight: false,
      smoothScrolling: false,
      smoothScrollingDuration: 300,
      // mobileDeceleration: 0.004,
      easing: 'sqrt',
      // easing: {
      //   easeInOut: function(p) {
      //     return 6*(p*p*p*p*p) - 15*(p*p*p*p) + 10*(p*p*p) + 0*(p*p) + 0*p;
      //   }
      // },

      // constants: {
      //   os: 60
      // },

      keyframe: function(element, name, direction) {
        // console.log($(element).html() + ' / ' + name + ' / ' + direction);
        $(element).trigger(name, [direction]);
      },
      mobileCheck: function() {
        // return $('html').hasClass('no-scroll');
        return false;
      }
    });

    var obj_refresh = function () {
      tt_skrollr_obj.refresh();
    }

    root_el.find('img').each(function () {
      var th = $(this);
      var src = th.attr("src");
      var image = new Image();
      image.src = src;
      image.complete ? obj_refresh() : image.onload = obj_refresh;
    });

    // $(window).on('resize.skrollr', obj_refresh);
    // console.log(tt_skrollr_obj);
  },

  kill: function (root_id) {
    var s = this;
    // console.log('root_id: ' + root_id);
    if (tt_skrollr_obj == undefined || root_id != s.root_el_name) return;

    // var root_el = s.root_el_name == 'html' ? $('html') : $('#' + s.root_el_name);
    // console.log(root_el);
    tt_skrollr_obj.destroy(true);
    tt_skrollr_obj = undefined;
    // console.log(tt_skrollr_obj);
  }

  // pjaxStart: function () {
  //   skrollrObj.destroy();
  //   skrollrObj = 0;
  // }
}
